import posthog from 'posthog-js';
import config from './config';

posthog.init(config.POSTHOG_KEY, {
  api_host: config.POSTHOG_API,
  ui_host: config.POSTHOG_UI,
  defaults: '2026-01-30',
  autocapture: false,
  capture_pageview: 'history_change',
  disable_session_recording: true,
  capture_exceptions: false,
});

export default posthog;
